import React, { createContext, useCallback, useContext, useState } from 'react';

const ExperimentContext = createContext();

const ExperimentProvider = ({ children }) => {
  const [experiments, setExperiments] = useState({
    homepageRefreshVariant1: false,
    homepageRefreshVariant2: false,
    paymentModuleVariant1: false,
    paymentModuleVariant2: false,
    updatedTrialLabels: false,
    quizHero: false,
    quizSectionModule: false,
    kidsBecomeCreatorsVariant1: false,
    kidsBecomeCreatorsVariant2: false,
    homepageRedesign: false,
    passPlanTagToAccounts: false,
    premiumOndemandClasses: false,
    premiumVsStandardDesign: false,
    premiumOndemandClassesTrials: true,
    differentPlanTrials: true,
  });

  const setExperimentStatus = useCallback((experiment, toggle) => {
    setExperiments(prevState => ({
      ...prevState,
      [experiment]: toggle,
    }));
  }, []);

  const value = {
    experiments,
    setExperimentStatus,
  };
  return <ExperimentContext.Provider value={value}>{children}</ExperimentContext.Provider>;
};

const useExperimentContext = () => useContext(ExperimentContext);

export {
  useExperimentContext,
  ExperimentProvider,
  // support classes
  ExperimentContext,
};



// WEBPACK FOOTER //
// ./src/experiments/context.js